<template>
  <div>
    <div class="head">
      <div class="head_img">
        <img src="../assets/boloni.jpg" />
        <ul>
          <li><a href="#" @click="ten()">相关资料</a></li>
          <li><a href="#" @click="nine()">主要原材料及配套厂家资料</a></li>
          <li><a href="#" @click="eight()">检测工具及设备</a></li>
          <li><a href="#" @click="seven()">主要生产设备</a></li>
          <li><a href="#" @click="twelve()">竞品客户信息</a></li>
          <li><a href="#" @click="six()">销售前五名客户</a></li>
          <li><a href="#" @click="five()">付款信息</a></li>
          <li><a href="#" @click="four()">人员信息</a></li>
          <li><a href="#" @click="eleven()">供货产品及产能</a></li>
          <li><a href="#" @click="three()">经营情况</a></li>
          <li><a href="#" @click="two()">基本信息</a></li>
          <li><a href="#" @click="one()">供货类型</a></li>
        </ul>
      </div>
    </div>
    <div class="main main_Mate">
      <div class="main_title">
        <span>相关资料</span>
      </div>
      <div class="item">
        <span class="item_title">请完善以下信息</span>
      </div>
      <div id="light" class="white_content" style="height: 75%;">
        <a
          class="close"
          href="javascript:void(0)"
          onclick="document.getElementById('light').style.display='none';"
          >关闭本窗口</a
        >
        <br />
        <img
          id="img"
          src="../assets/boloni.jpg"
          style="width: 1000px;height: 700px;"
        />
        <img
          id="img1"
          src=""
          style="width: 1000px;height: 500px; display: none;"
        />
        <img
          id="img2"
          src=""
          style="width: 1000px;height: 500px; display: none;"
        />
        <img
          id="img3"
          src=""
          style="width: 1000px;height: 500px; display: none;"
        />
        <br />
      </div>
      <div class="main_info">
        <div class="user-mate">
          <el-form ref="form" :model="MateFrom">
            <el-form-item label="必要材料">
              <el-input
                placeholder="必要材料"
                v-model="MateFrom.gh_cl"
                :disabled="true"
              ></el-input>
              <!--            <el-input  placeholder="必要材料"  v-html="cutout(MateFrom.gh_cl)" :disabled="true" ></el-input>-->
            </el-form-item>
            <table border="1" style="border-collapse: collapse;width: 100%;">
              <tr>
                <th>资料名称</th>
                <th>附件上传</th>
                <th>资料名称</th>
                <th>附件上传</th>
                <th>有效日期</th>
              </tr>
              <tr>
                <td @click="openImg('gsjj.png', '', '', '')"><span class="Required" v-if="gsjj==2">*</span>公司简介</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.comp_about"
                        :on-preview="file => fileDownload(file, 'comp_about')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'comp_about')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'comp_about')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('yyzz.png', '', '', '')">
                  <span class="Required" v-if="yyzz==2">*</span>营业执照（三证合一）
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_yyzz"
                        :on-preview="file => fileDownload(file, 'xgzl_yyzz')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_yyzz')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_yyzz')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible" append-to-body>
                        <img
                          width="100%"
                          fit="contain"
                          :src="dialogImageUrl"
                          alt=""
                        />
                      </el-dialog>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.yyzz_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('sfz.png', '', '', '')"><span class="Required" v-if="sfz==2">*</span>法人身份证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.person_id"
                        :on-preview="file => fileDownload(file, 'person_id')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'person_id')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'person_id')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td
                  @click="
                    openImg('cpjc1.png', 'cpjc2.png', 'cpjc3.png', 'cpjc4.png')
                  "
                >
                <span class="Required" v-if="cpjc==2">*</span>产品检测报告
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_cpjc"
                        :on-preview="file => fileDownload(file, 'xgzl_cpjc')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_cpjc')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_cpjc')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.cpjc_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('zzjg.png', '', '', '')"><span class="Required" v-if="zzjg==2">*</span>组织架构图</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.comp_zuzhi"
                        :on-preview="file => fileDownload(file, 'comp_zuzhi')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'comp_zuzhi')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'comp_zuzhi')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('scxk.png', '', '', '')"><span class="Required" v-if="scxk==2">*</span>生产许可证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_scxk"
                        :on-preview="file => fileDownload(file, 'xgzl_scxk')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_scxk')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_scxk')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.scxk_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('nsrzm1.png', 'nsrzm2.png', '', '')">
                  <span class="Required" v-if="nsrzm==2">*</span>一般纳税人证明
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_nxrzm"
                        :on-preview="file => fileDownload(file, 'xgzl_nxrzm')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_nxrzm')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_nxrzm')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('aqscxk.png', '', '', '')">
                  <span class="Required" v-if="aqxk==2">*</span>安全生产许可证
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_aqxk"
                        :on-preview="file => fileDownload(file, 'xgzl_aqxk')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_aqxk')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_aqxk')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.aqxk_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('hjbh1.png', 'hjbh2.png', 'hjbh3.png', '')">
                  <span class="Required" v-if="hjbh==2">*</span>环境保护验收报告
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_hjbh"
                        :on-preview="file => fileDownload(file, 'xgzl_hjbh')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_hjbh')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_hjbh')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('wrw.png', '', '', '')">
                  <span class="Required" v-if="wrw==2">*</span>污染物排放许可证
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_wrw"
                        :on-preview="file => fileDownload(file, 'xgzl_wrw')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_wrw')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_wrw')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.wrw_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('xf.png', '', '', '')"><span class="Required" v-if="xf==2">*</span>消防验收合格证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_xfys"
                        :on-preview="file => fileDownload(file, 'xgzl_xfys')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_xfys')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_xfys')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('ys.png', '', '', '')"><span class="Required" v-if="jyys==2">*</span>印刷许可证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_jyys"
                        :on-preview="file => fileDownload(file, 'xgzl_jyys')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_jyys')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_jyys')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.jyys_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('shrz.png', '', '', '')"><span class="Required" v-if="shrz==2">*</span>十环认证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_ring"
                        :on-preview="file => fileDownload(file, 'xgzl_ring')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_ring')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_ring')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('3c.png', '', '', '')"><span class="Required" v-if="ccc==2">*</span>3C认证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_ccc"
                        :on-preview="file => fileDownload(file, 'xgzl_ccc')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_ccc')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_ccc')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.ccc_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('', '', '', '')"><span class="Required" v-if="skillfile==2">*</span>技术文件</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.skill_file"
                        :on-preview="file => fileDownload(file, 'skill_file')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'skill_file')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'skill_file')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('wx.png', '', '', '')">
                  <span class="Required" v-if="wxp==2">*</span>危险化学品经营许可证
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_wxp"
                        :on-preview="file => fileDownload(file, 'xgzl_wxp')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_wxp')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_wxp')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.wxp_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('zlgl.png', '', '', '')"><span class="Required" v-if="qms==2">*</span>质量管理文件</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.quality_file"
                        :on-preview="file => fileDownload(file, 'quality_file')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'quality_file')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'quality_file')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('gjcp.png', '', '', '')"><span class="Required" v-if="gjcp==2">*</span>国际产品认证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_gjcp"
                        :on-preview="file => fileDownload(file, 'xgzl_gjcp')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_gjcp')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_gjcp')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.gjcp_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('.png', '', '', '')"><span class="Required" v-if="personfile==2">*</span>人员管理文件</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.person_file"
                        :on-preview="file => fileDownload(file, 'person_file')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'person_file')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'person_file')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('zlgl.png', '', '', '')"><span class="Required" v-if="qms==2">*</span>质量管理体系</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_qms"
                        :on-preview="file => fileDownload(file, 'xgzl_qms')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_qms')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_qms')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.qms_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td @click="openImg('.png', '', '', '')"><span class="Required" v-if="otherfile==2">*</span>其他文件</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_other"
                        :on-preview="file => fileDownload(file, 'xgzl_other')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_other')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_other')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('hjgl.png', '', '', '')"><span class="Required" v-if="ems==2">*</span>环境管理体系</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_ems"
                        :on-preview="file => fileDownload(file, 'xgzl_ems')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_ems')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_ems')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.ems_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td><span class="Required" v-if="bnlse==2">*</span> 半年流水额附件</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_bnlse"
                        :on-preview="file => fileDownload(file, 'xgzl_bnlse')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_bnlse')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_bnlse')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td @click="openImg('zyjk.png', '', '', '')">
                  <span class="Required" v-if="zyjk==2">*</span> 职业健康安全管理体系
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_zyjk"
                        :on-preview="file => fileDownload(file, 'xgzl_zyjk')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_zyjk')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_zyjk')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.zyjk_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td @click="openImg('gxjs.png', '', '', '')">
                  <span class="Required" v-if="gxqy==2">*</span>高新技术企业认证
                </td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_gxqy"
                        :on-preview="file => fileDownload(file, 'xgzl_gxqy')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_gxqy')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_gxqy')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.gxqy_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td @click="openImg('sbzc.png', '', '', '')"><span class="Required" v-if="xbzc==2">*</span>商标注册证</td>
                <td>
                  <el-col :span="24">
                    <el-form-item>
                      <el-upload
                        :action="postUrl"
                        multiple
                        :limit="5"
                        name="docFile0"
                        :file-list="fileList.xgzl_xbzc"
                        :on-preview="file => fileDownload(file, 'xgzl_xbzc')"
                        :on-success="
                          (response, file) =>
                            handleAvatarSuccess(response, file, 'xgzl_xbzc')
                        "
                        :before-remove="
                          (file, filelist) =>
                            fileRemove(file, filelist, 'xgzl_xbzc')
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <el-button size="small" class="file"
                          >点击上传</el-button
                        >
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </td>
                <td>
                  <el-col :span="24">
                    <el-date-picker
                      v-model="MateFrom.xbzc_date"
                      type="date"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-col>
                </td>
              </tr>
            </table>

            <!-- 						<el-form-item label="未上传的必要资料">
							<label slot="label">&nbsp;&nbsp;未上传的必要资料</label>
							<el-input placeholder="未上传的必要资料" v-model="MateFrom.byzl_no" :disabled="true"></el-input>
						</el-form-item> -->
          </el-form>

          <div class="payment_info_button">
            <button type="button" @click="openMateLine()">
              <span>上一步</span>
            </button>
            <button
              type="button"
              style="background-color: #27eaff"
              @click="udMate()"
            >
              <span>保存</span>
            </button>
            <button  v-if="bSaved"
              type="button"
              style="background-color: #ce6a14"
              @click="submit()"
            >
              <span>提交</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { udMate, getGys, getGhCl, doSubmit} from '../api/LoginApi'
import { goBack, Transformation } from '../utils/Transformation'
import { messageSuCcEss, messageError } from '../utils/message'
import BigImg from './BigImg'
import { notZl } from '../utils/NotZl'
export default {
  name: 'GysMate',
  data: function () {
    return {
      showImg: false,
      imgSrc: '',
      fileUrl: '/downloadfile?docid=',
      postUrl:
        '/web/cpc/filesuploadsave2.do?loginguid=' +
        localStorage.getItem('loginguid'),
      dialogImageUrl: '',
      dialogVisible: false,
      MateFrom: {
        gys_no: localStorage.getItem('userName'),
        comp_about: '',
        person_id: '',
        comp_zuzhi: '',
        gh_cl: '',
        yyzz_date: null,
        nxrzm_date: '长期',
        cpjc_date: null,
        scxk_date: null,
        aqxk_date: null,
        wrw_date: null,
        jyys_date: null,
        ccc_date: null,
        wxp_date: null,
        gjcp_date: null,
        qms_date: null,
        ems_date: null,
        zyjk_date: null,
        gxqy_date: null,
        xbzc_date: null,
        byzl_no: '',
        xgzl_yyzz: '',
        xgzl_nxrzm: '',
        xgzl_hjbh: '',
        xgzl_xfys: '',
        xgzl_cpjc: '',
        xgzl_scxk: '',
        xgzl_aqxk: '',
        xgzl_wrw: '',
        xgzl_jyys: '',
        xgzl_ccc: '',
        xgzl_wxp: '',
        xgzl_gjcp: '',
        xgzl_qms: '',
        xgzl_ems: '',
        xgzl_zyjk: '',
        xgzl_gxqy: '',
        xgzl_xbzc: '',
        xgzl_ring: '',
        skill_file: '',
        person_file: '',
        quality_file: '',
        xgzl_other: '',
        xgzl_bnlse: ''
      },
      fileList: {
        comp_about: [],
        person_id: [],
        comp_zuzhi: [],
        xgzl_yyzz: [],
        xgzl_nxrzm: [],
        xgzl_hjbh: [],
        xgzl_xfys: [],
        xgzl_cpjc: [],
        xgzl_scxk: [],
        xgzl_aqxk: [],
        xgzl_wrw: [],
        xgzl_jyys: [],
        xgzl_ccc: [],
        xgzl_wxp: [],
        xgzl_gjcp: [],
        xgzl_qms: [],
        xgzl_ems: [],
        xgzl_zyjk: [],
        xgzl_gxqy: [],
        xgzl_xbzc: [],
        xgzl_ring: [],
        skill_file: [],
        person_file: [],
        quality_file: [],
        xgzl_other: [],
        xgzl_bnlse: []
      },
      fileList1: {
        comp_about: [],
        person_id: [],
        comp_zuzhi: [],
        xgzl_yyzz: [],
        xgzl_nxrzm: [],
        xgzl_hjbh: [],
        xgzl_xfys: [],
        xgzl_cpjc: [],
        xgzl_scxk: [],
        xgzl_aqxk: [],
        xgzl_wrw: [],
        xgzl_jyys: [],
        xgzl_ccc: [],
        xgzl_wxp: [],
        xgzl_gjcp: [],
        xgzl_qms: [],
        xgzl_ems: [],
        xgzl_zyjk: [],
        xgzl_gxqy: [],
        xgzl_xbzc: [],
        xgzl_ring: [],
        skill_file: [],
        person_file: [],
        quality_file: [],
        xgzl_other: [],
        xgzl_bnlse: []
      },
      gsjj: 1,//公司简介
      sfz: 1,//法人身份证
      zzjg: 1,//组织架构图
      nsrzm: 1,//一般纳税人证明
      hjbh: 1,//环境保护验收报告
      xf: 1,//消防验收合格证
      shrz: 1,//十环认证
      skillfile: 1,//技术文件
      qualityfile: 1,//质量管理文件
      personfile: 1,//人员管理文件
      otherfile: 1,//其他文件
      yyzz: 1,//营业执照（三证合一）
      cpjc: 1,//产品检测报告
      scxk: 1,//生产许可证
      aqxk: 1,//安全生产许可证
      wrw: 1,//污染物排放许可证
      ccc: 1,//3C认证
      wxp: 1,//危险化学品经营许可证
      gjcp: 1,//国际产品认证
      qms: 1,//质量管理体系
      ems: 1,//环境管理体系
      zyjk: 1,//职业健康安全管理体系
      gxqy: 1,//高新技术企业认证
      xbzc: 1,//商标注册证 
      jyys: 1,//印刷许可证
      bnlse: 1,//半年流水额
      bSaved: false //保存标记，用来控制[提交]按钮
    }
  },
  created () {
    this.getMate()
  },
  mounted () {
    // 页面刷新时清除localStorage
    window.onbeforeunload = function (e) {
      let storage = window.localStorage
      storage.clear()
    }
    // localStorage不存在loginguid则跳到登录页面
    if (!localStorage.getItem('loginguid')) {
      const vm = this
      vm.$router.push({
        path: '/Login'
      })
    }
    // 不允许使用页面返回按钮
    if (window.history && window.history.pushState) {
      // 向历史记录中插入了当前页
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', goBack, false)
    }
  },
  destroyed () {
    window.removeEventListener('popstate', goBack, false)
  },
  components: {
    BigImg
  },
  methods: {
    // 图片预览
    // clickImg(e) {
    // 	if (e != '') {
    // 		this.showImg = true
    // 		this.imgSrc = e.currentTarget.src
    // 	}
    // },
    openImg (imgSrc, imgSrc1, imgSrc2, imgSrc3) {
      document.getElementById('light').style.display = 'block'
      // document.getElementById('fade').style.display='block'
      if (imgSrc) {
        var obj = document.getElementById('img')
        document.getElementById('img').style.display = 'block'
        obj.src = 'static/img/' + imgSrc
      }
      if (imgSrc1) {
        var obj1 = document.getElementById('img1')
        document.getElementById('img1').style.display = 'block'
        obj1.src = 'static/img/' + imgSrc1
      }
      if (imgSrc2) {
        var obj2 = document.getElementById('img2')
        document.getElementById('img2').style.display = 'block'
        obj2.src = 'static/img/' + imgSrc2
      }
      if (imgSrc3) {
        var obj3 = document.getElementById('img3')
        document.getElementById('img3').style.display = 'block'
        obj3.src = 'static/img/' + imgSrc3
      }
    },
    // 根据逗号换行
    cutout (cellValue) {
      return cellValue.replace(/\,/g, '</br>')
    },
    // 上一个页面
    openMateLine: function () {
      const vm = this
      vm.$router.push({
        path: '/GysMateLine'
      })
    },

    one () {
      const vm = this
      vm.$router.push({
        path: '/GysBasic'
      })
    },
    two () {
      const vm = this
      vm.$router.push({
        path: '/Bas_info'
      })
    },
    three () {
      const vm = this
      vm.$router.push({
        path: '/Operation'
      })
    },
    four () {
      const vm = this
      vm.$router.push({
        path: '/Personnel_info'
      })
    },
    five () {
      const vm = this
      vm.$router.push({
        path: '/Payment_info'
      })
    },
    six () {
      const vm = this
      vm.$router.push({
        path: '/GysCooPeRate'
      })
    },
    seven () {
      const vm = this
      vm.$router.push({
        path: '/GysMainLine'
      })
    },
    eight () {
      const vm = this
      vm.$router.push({
        path: '/GysTestLine'
      })
    },
    nine () {
      const vm = this
      vm.$router.push({
        path: '/GysMateLine'
      })
    },
    ten () {
      const vm = this
      vm.$router.push({
        path: '/GysMate'
      })
    },
		eleven() {
				const vm = this
				vm.$router.push({
					path: '/ProductsCapacity'
				})
		},
		twelve() {
			const vm = this
			vm.$router.push({
				path: '/CompetitorcustInfo'
			})
		},
    // 查询数据
    getMate: function () {
      getGys(localStorage.getItem('userName')).then(res => {
        if (res) {
          this.MateFrom = res
          console.log("gysmate: ",res);
          // 将数据库数据转为数组存入对应的file-list 不为空时赋值，否则会报错
          if (res.comp_about) {
            this.fileList.comp_about = JSON.parse(res.comp_about)
          }
          if (res.person_id) {
            this.fileList.person_id = JSON.parse(res.person_id)
          }
          if (res.comp_zuzhi) {
            this.fileList.comp_zuzhi = JSON.parse(res.comp_zuzhi)
          }
          if (res.xgzl_yyzz) {
            this.fileList.xgzl_yyzz = JSON.parse(res.xgzl_yyzz)
          }
          if (res.xgzl_nxrzm) {
            this.fileList.xgzl_nxrzm = JSON.parse(res.xgzl_nxrzm)
          }
          if (res.xgzl_hjbh) {
            this.fileList.xgzl_hjbh = JSON.parse(res.xgzl_hjbh)
          }
          if (res.xgzl_xfys) {
            this.fileList.xgzl_xfys = JSON.parse(res.xgzl_xfys)
          }
          if (res.xgzl_cpjc) {
            this.fileList.xgzl_cpjc = JSON.parse(res.xgzl_cpjc)
          }
          if (res.xgzl_scxk) {
            this.fileList.xgzl_scxk = JSON.parse(res.xgzl_scxk)
          }
          if (res.xgzl_aqxk) {
            this.fileList.xgzl_aqxk = JSON.parse(res.xgzl_aqxk)
          }
          if (res.xgzl_wrw) {
            this.fileList.xgzl_wrw = JSON.parse(res.xgzl_wrw)
          }
          if (res.xgzl_jyys) {
            this.fileList.xgzl_jyys = JSON.parse(res.xgzl_jyys)
          }
          if (res.xgzl_ccc) {
            this.fileList.xgzl_ccc = JSON.parse(res.xgzl_ccc)
          }
          if (res.xgzl_wxp) {
            this.fileList.xgzl_wxp = JSON.parse(res.xgzl_wxp)
          }
          if (res.xgzl_gjcp) {
            this.fileList.xgzl_gjcp = JSON.parse(res.xgzl_gjcp)
          }
          if (res.xgzl_qms) {
            this.fileList.xgzl_qms = JSON.parse(res.xgzl_qms)
          }
          if (res.xgzl_ems) {
            this.fileList.xgzl_ems = JSON.parse(res.xgzl_ems)
          }
          if (res.xgzl_zyjk) {
            this.fileList.xgzl_zyjk = JSON.parse(res.xgzl_zyjk)
          }
          if (res.xgzl_gxqy) {
            this.fileList.xgzl_gxqy = JSON.parse(res.xgzl_gxqy)
          }
          if (res.xgzl_xbzc) {
            this.fileList.xgzl_xbzc = JSON.parse(res.xgzl_xbzc)
          }
          if (res.xgzl_ring) {
            this.fileList.xgzl_ring = JSON.parse(res.xgzl_ring)
          }
          if (res.skill_file) {
            this.fileList.skill_file = JSON.parse(res.skill_file)
          }
          if (res.person_file) {
            this.fileList.person_file = JSON.parse(res.person_file)
          }
          if (res.quality_file) {
            this.fileList.quality_file = JSON.parse(res.quality_file)
          }
          if (res.xgzl_other) {
            this.fileList.xgzl_other = JSON.parse(res.xgzl_other)
          }
          if (res.xgzl_bnlse) {
            this.fileList.xgzl_bnlse = JSON.parse(res.xgzl_bnlse)
          }
          
        }

        if (res.gh_cl == null) {
          var gh_type = localStorage.getItem('gh_type')
          gh_type = gh_type.replace(/'/g, '')
          console.log("gh_type",gh_type);
          getGhCl(gh_type).then(res1 => {
            this.MateFrom.gh_cl = res1.gh_cl;
            res.gh_cl == res1.gh_cl;
          })
        }
        
        //初始化必填资料
        if(res.gh_cl){
              var ghcls = res.gh_cl.split(",");
              for(var i = 0; i < ghcls.length; i++){
                if(ghcls[i].indexOf("公司简介") > -1){
                  this.gsjj = 2;
                }else if(ghcls[i].indexOf("身份证") > -1){
                  this.sfz = 2;
                }else if(ghcls[i].indexOf("组织架构") > -1){
                  this.zzjg = 2;
                }else if(ghcls[i].indexOf("纳税人证明") > -1){
                  this.nsrzm = 2;
                }else if(ghcls[i].indexOf("环境保护") > -1){
                  this.hjbh = 2;
                }else if(ghcls[i].indexOf("消防验收") > -1){
                  this.xf = 2;
                }else if(ghcls[i].indexOf("十环认证") > -1){
                  this.shrz = 2;
                }else if(ghcls[i].indexOf("技术文件") > -1){
                  this.skillfile = 2;
                }else if(ghcls[i].indexOf("质量管理") > -1){
                  this.qualityfile = 2;
                }else if(ghcls[i].indexOf("人员管理") > -1){
                  this.personfile = 2;
                }else if(ghcls[i].indexOf("其他文件") > -1){
                  this.otherfile = 2;
                }else if(ghcls[i].indexOf("营业执照") > -1){
                  this.yyzz = 2;
                }else if(ghcls[i].indexOf("产品检测") > -1){
                  this.cpjc = 2;
                }else if(ghcls[i].indexOf("生产许可") > -1){
                  this.scxk = 2;
                }else if(ghcls[i].indexOf("安全生产") > -1){
                  this.aqxk = 2;
                }else if(ghcls[i].indexOf("污染物排放") > -1){
                  this.wrw = 2;
                }else if(ghcls[i].indexOf("3C认证") > -1){
                  this.ccc = 2;
                }else if(ghcls[i].indexOf("危险化学") > -1){
                  this.wxp = 2;
                }else if(ghcls[i].indexOf("国际产品认证") > -1){
                  this.gjcp = 2;
                }else if(ghcls[i].indexOf("质量管理体系") > -1){
                  this.qms = 2;
                }else if(ghcls[i].indexOf("环境管理体系") > -1){
                  this.ems = 2;
                }else if(ghcls[i].indexOf("职业健康") > -1){
                  this.zyjk = 2;
                }else if(ghcls[i].indexOf("高新技术") > -1){
                  this.gxqy = 2;
                }else if(ghcls[i].indexOf("商标注册") > -1){
                  this.xbzc = 2;
                }else if(ghcls[i].indexOf("印刷许可") > -1){
                  this.jyys = 2;
                }else if(ghcls[i].indexOf("半年流水额附件") > -1){
                  this.bnlse = 2;
                }
              }
        }
      })
    },
    // 数组去重方法
    unique: function (st) {
      const tmp = []
      for (let i in st) {
        if (tmp.indexOf(st[i]) === -1) {
          tmp.push(st[i])
        }
      }
      return tmp
    },
    // 文件上传成功回调
    handleAvatarSuccess: async function (res, file, fileName) {
      // console.log('res', res)
      // console.log('res.data', res.data)
      if (res.data) {
        // alert('文件上传成功，文件ID是：' + res.data[0].docid)
        // 文件上传成功后加入,把路径以及名称加入对应的数组
        // （问题：用一个数组会出现不能多个附件同时上传，所以改为两个数组）先存入fileList1在将fileList1插入fileList
        this.fileList1[fileName].push({
          docid: res.data[0].docid,
          name: file.name,
          url: this.fileUrl + res.data[0].docid
        })
        // 将一个fileList1内容存入fileList
        Array.prototype.push.apply(
          this.fileList[fileName],
          this.fileList1[fileName]
        )
        // console.log('去重fileList', this.unique(this.fileList[fileName]));
        // console.log('fileList', this.fileList[fileName])
        // 去重复之后再将file-list数据加入from
        this.MateFrom[fileName] = JSON.stringify(
          this.unique(this.fileList[fileName])
        )
      }
    },
    beforeAvatarUpload (file) {
      // console.log('file2', file)
    },
    // 文件下载
    fileDownload: function (file, fileName) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
      // console.log(file.url)
      if (this.fileList[fileName].length > 0) {
        window.open(file.url)
        window.close()
      } else {
        alert('请先上传文件！')
      }
    },
    // 文件删除
    fileRemove: function (file, filelist, fileName) {
      /* 删除文件 */
      let index = this.fileList[fileName].indexOf(file)
      let newFileList = this.fileList[fileName].slice()
      newFileList.splice(index, 1)
      this.fileList[fileName] = newFileList
      this.MateFrom[fileName] = JSON.stringify(this.fileList[fileName])
      console.log('点击了删除', this.fileList[fileName])
      // return this.$confirm(`确定移除 ${file.name}？`)
    },
    // 保存数据
    udMate: function () {
      if (this.MateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
			}

      this.MateFrom.yyzz_date = this.MateFrom.yyzz_date
        ? Transformation(this.MateFrom.yyzz_date)
        : ''
      this.MateFrom.nxrzm_date = this.MateFrom.nxrzm_date
        ? Transformation(this.MateFrom.nxrzm_date)
        : ''
      this.MateFrom.cpjc_date = this.MateFrom.cpjc_date
        ? Transformation(this.MateFrom.cpjc_date)
        : ''
      this.MateFrom.scxk_date = this.MateFrom.scxk_date
        ? Transformation(this.MateFrom.scxk_date)
        : ''
      this.MateFrom.aqxk_date = this.MateFrom.aqxk_date
        ? Transformation(this.MateFrom.aqxk_date)
        : ''
      this.MateFrom.wrw_date = this.MateFrom.wrw_date
        ? Transformation(this.MateFrom.wrw_date)
        : ''
      this.MateFrom.jyys_date = this.MateFrom.jyys_date
        ? Transformation(this.MateFrom.jyys_date)
        : ''
      this.MateFrom.ccc_date = this.MateFrom.ccc_date
        ? Transformation(this.MateFrom.ccc_date)
        : ''
      this.MateFrom.wxp_date = this.MateFrom.wxp_date
        ? Transformation(this.MateFrom.wxp_date)
        : ''
      this.MateFrom.gjcp_date = this.MateFrom.gjcp_date
        ? Transformation(this.MateFrom.gjcp_date)
        : ''
      this.MateFrom.qms_date = this.MateFrom.qms_date
        ? Transformation(this.MateFrom.qms_date)
        : ''
      this.MateFrom.ems_date = this.MateFrom.ems_date
        ? Transformation(this.MateFrom.ems_date)
        : ''
      this.MateFrom.zyjk_date = this.MateFrom.zyjk_date
        ? Transformation(this.MateFrom.zyjk_date)
        : ''
      this.MateFrom.gxqy_date = this.MateFrom.gxqy_date
        ? Transformation(this.MateFrom.gxqy_date)
        : ''
      this.MateFrom.xbzc_date = this.MateFrom.xbzc_date
        ? Transformation(this.MateFrom.xbzc_date)
        : ''
      this.MateFrom.byzl_no = '' 

      //营业执照（三证合一）
      if (this.fileList.xgzl_yyzz.length > 0 &&  this.MateFrom.yyzz_date == ''
        // (this.fileList.comp_about.length > 0 && this.MateFrom.yyzz_date == '')
      ) {
        return messageError('第1行有效日期必填!')
      }
      if (this.yyzz == 2 && this.fileList.xgzl_yyzz.length == 0){
          return messageError("[营业执照（三证合一）]必填!");
      }
      //产品检测报告
      if (this.fileList.xgzl_cpjc.length > 0 && this.MateFrom.cpjc_date == '') {
        return messageError('第2行有效日期必填!')
      }
      if (this.cpjc == 2 && this.fileList.xgzl_cpjc.length == 0){
          return messageError('[产品检测报告]必填!');
      }
      //生产许可证
      if (
        // this.fileList.comp_zuzhi.length > 0 ||
        this.fileList.xgzl_scxk.length > 0 &&
        this.MateFrom.scxk_date == ''
      ) {
        return messageError('第3有效日期必填!')
      }
      if (this.scxk == 2 && this.fileList.xgzl_scxk.length == 0){
          return messageError('[生产许可证]必填!');
      }

      //安全生产许可证
      if (
        // this.fileList.xgzl_nxrzm.length > 0 ||
        this.fileList.xgzl_aqxk.length > 0 &&
        this.MateFrom.aqxk_date == ''
      ) {
        return messageError('第4行有效日期必填!')
      }
      if (this.aqxk == 2 && this.fileList.xgzl_aqxk.length == 0){
          return messageError('[安全生产许可证]必填!');
      }

      //污染物排放许可证
      if (
        // this.fileList.xgzl_hjbh.length > 0 ||
        this.fileList.xgzl_wrw.length > 0 &&
        this.MateFrom.wrw_date == ''
      ) {
        return messageError('第5行有效日期必填!')
      }
      if (this.wrw == 2 && this.fileList.xgzl_wrw.length == 0){
          return messageError('[污染物排放许可证]必填!');
      }
      //印刷许可证
      if (
        // this.fileList.xgzl_xfys.length > 0 ||
        this.fileList.xgzl_jyys.length > 0 &&
        this.MateFrom.jyys_date == ''
      ) {
        return messageError('第6行有效日期必填!')
      }
      if (this.jyys == 2 && this.fileList.xgzl_jyys.length == 0){
          return messageError('[印刷许可证]必填!');
      }
      //3C认证
      if (
        // this.fileList.xgzl_ring.length > 0 ||
        this.fileList.xgzl_ccc.length > 0 &&
        this.MateFrom.ccc_date == ''
      ) {
        return messageError('第7行有效日期必填!')
      }
      if (this.ccc == 2 && this.fileList.xgzl_ccc.length == 0){
          return messageError('[3C认证]必填!');
      }
      //危险化学品经营许可证
      if (
        // this.fileList.skill_file.length > 0 ||
        this.fileList.xgzl_wxp.length > 0 &&
        this.MateFrom.wxp_date == ''
      ) {
        return messageError('第8行有效日期必填!')
      }
      if (this.wxp == 2 && this.fileList.xgzl_wxp.length == 0){
          return messageError('[危险化学品经营许可证]必填!');
      }
      //国际产品认证
      if (
        // this.fileList.quality_file.length > 0 ||
        this.fileList.xgzl_gjcp.length > 0 &&
        this.MateFrom.gjcp_date == ''
      ) {
        return messageError('第9行有效日期必填!')
      }
      if (this.gjcp == 2 && this.fileList.xgzl_gjcp.length == 0){
          return messageError('[国际产品认证]必填!');
      }
      //质量管理体系
      if (this.fileList.xgzl_qms.length > 0 && this.MateFrom.qms_date == '') {
        return messageError('第10行有效日期必填!')
      }
      if (this.qms == 2 && this.fileList.xgzl_qms.length == 0){
          return messageError('[质量管理体系]必填!');
      }
      //环境管理体系
      if (this.fileList.xgzl_ems.length > 0 && this.MateFrom.ems_date == '') {
        return messageError('第11行有效日期必填!')
      }
      if (this.ems == 2 && this.fileList.xgzl_ems.length == 0){
          return messageError('[环境管理体系]必填!');
      }
      //职业健康安全管理体系
      if (this.fileList.xgzl_zyjk.length > 0 && this.MateFrom.zyjk_date == '') {
        return messageError('第12行有效日期必填!')
      }
      if (this.zyjk == 2 && this.fileList.xgzl_zyjk.length == 0){
          return messageError('[职业健康安全管理体系]必填!');
      }
      //高新技术企业认证
      if (this.fileList.xgzl_gxqy.length > 0 && this.MateFrom.gxqy_date == '') {
        return messageError('第13行有效日期必填!')
      }
      if (this.gxqy == 2 && this.fileList.xgzl_gxqy.length == 0){
          return messageError('[高新技术企业认证]必填!');
      }
      //商标注册证
      if (this.fileList.xgzl_xbzc.length > 0 && this.MateFrom.xbzc_date == '') {
        return messageError('第14行有效日期必填!')
      }
      if (this.xbzc == 2 && this.fileList.xgzl_xbzc.length == 0){
          return messageError('[商标注册证]必填!');
      }
      //其他文件
      if (this.otherfile == 2 && this.fileList.xgzl_other.length == 0){
          return messageError('[其他文件]必填!');
      }
      //半年流水额附件
      if (this.xgzl_bnlse == 2 && this.fileList.xgzl_bnlse.length == 0){
          return messageError('[半年流水额附件]必填!');
      } 
      
      //人员管理文件
      if (this.personfile == 2 && this.fileList.person_file.length == 0){
          return messageError('[人员管理文件]必填!');
      }
      //质量管理文件
      if (this.qualityfile == 2 && this.fileList.quality_file.length == 0){
          return messageError('[质量管理文件]必填!');
      }
      //技术文件
      if (this.skillfile == 2 && this.fileList.skill_file.length == 0){
          return messageError('[技术文件]必填!');
      }
      //十环认证
      if (this.shrz == 2 && this.fileList.xgzl_ring.length == 0){
          return messageError('[十环认证]必填!');
      }
      //消防验收合格证
      if (this.xf == 2 && this.fileList.xgzl_xfys.length == 0){
          return messageError('[消防验收合格证]必填!');
      }
      //环境保护验收报告
      if (this.hjbh == 2 && this.fileList.xgzl_hjbh.length == 0){
          return messageError('[环境保护验收报告]必填!');
      }
      //一般纳税人证明
      if (this.nsrzm == 2 && this.fileList.xgzl_nxrzm.length == 0){
          return messageError('[一般纳税人证明]必填!');
      }
      //组织架构图
      if (this.zzjg == 2 && this.fileList.comp_zuzhi.length == 0){
          return messageError('[组织架构图]必填!');
      }
      //法人身份证
      if (this.sfz == 2 && this.fileList.person_id.length == 0){
          return messageError('[法人身份证]必填!');
      }
      //公司简介
      if (this.gsjj == 2 && this.fileList.comp_about.length == 0){
          return messageError('[公司简介]必填!');
      }

      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_yyzz,
        this.MateFrom.gh_cl,
        '营业执照（三证合一）',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_nxrzm,
        this.MateFrom.gh_cl,
        '一般纳税人证明',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_hjbh,
        this.MateFrom.gh_cl,
        '环境保护验收报告',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_xfys,
        this.MateFrom.gh_cl,
        '消防验收合格证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_cpjc,
        this.MateFrom.gh_cl,
        '产品检测报告',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_scxk,
        this.MateFrom.gh_cl,
        '生成许可证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_aqxk,
        this.MateFrom.gh_cl,
        '安全生产许可证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_wrw,
        this.MateFrom.gh_cl,
        '污染物排放许可证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_jyys,
        this.MateFrom.gh_cl,
        '经营印刷许可证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_ccc,
        this.MateFrom.gh_cl,
        '3C认证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_wxp,
        this.MateFrom.gh_cl,
        '危险化学品经营许可证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_gjcp,
        this.MateFrom.gh_cl,
        '国际产品认证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_qms,
        this.MateFrom.gh_cl,
        '质量管理体系',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_ems,
        this.MateFrom.gh_cl,
        '环境管理体系',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_zyjk,
        this.MateFrom.gh_cl,
        '职业健康安全管理体系',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_gxqy,
        this.MateFrom.gh_cl,
        '高新技术企业认证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_xbzc,
        this.MateFrom.gh_cl,
        '商标注册证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_ring,
        this.MateFrom.gh_cl,
        '十环认证',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.skill_file,
        this.MateFrom.gh_cl,
        '技术文件',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.person_file,
        this.MateFrom.gh_cl,
        '人员管理文件',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.quality_file,
        this.MateFrom.gh_cl,
        '质量管理文件',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_other,
        this.MateFrom.gh_cl,
        '其它证件',
        this.MateFrom.byzl_no
      )
      this.MateFrom.byzl_no = notZl(
        this.fileList.xgzl_bnlse,
        this.MateFrom.gh_cl,
        '半年流水额附件',
        this.MateFrom.byzl_no
      )
      
      udMate(this.MateFrom).then(res => {
        if (res.code === 200) {
          this.bSaved = true;
          messageSuCcEss(res.msg);
          this.getMate(); 
        } else {
          messageError(res.msg)
        }
      })
    },
    
    //提交
    submit: function () {
     //供货类型信息校验 
      if (this.MateFrom.bill_status == '已审核') {
					return messageError('资料已审核不允许修改!')
			}

			if (!this.MateFrom.name_all) {
				return messageError('供应商全称必填!')
			}
			if (!this.MateFrom.name_jc) {
				return messageError('供应商简称必填!')
			}
			if (!this.MateFrom.gys_ghdl) {
				return messageError('供货大类必填!')
			}
			if (!this.MateFrom.gh_type) {
				return messageError('供货小类必填!')
			} 

      //基本信息
      if (!this.MateFrom.gys_provnice) {
				return messageError('所在省份必填!')
			}
			if (!this.MateFrom.gys_city) {
				return messageError('所在城市必填!')
			}
			if (!this.MateFrom.gys_address) {
				return messageError('公司地址必填!')
			}
			if (!this.MateFrom.gys_mail) {
				return messageError('公司邮箱必填!')
			}
			if (!this.MateFrom.contact_man) {
				return messageError('总经理姓名必填!')
			}
			if (!this.MateFrom.contact_num) {
				return messageError('总经理电话必填!')
			}
			if (!this.MateFrom.contact_man1) {
				return messageError('业务经理姓名必填!')
			}
			if (!this.MateFrom.contact_num1) {
				return messageError('业务经理电话必填!')
			}

      //经营情况 
			if (!this.MateFrom.fac_from) {
				return messageError('工厂所属必填!')
			}
			if (!this.MateFrom.fac_area) {
				return messageError('工厂面积必填!')
			}
			if (!this.MateFrom.gys_sales) {
				return messageError('全年营业额(万元)必填!')
			}
			if (!this.MateFrom.gys_zczj) {
				return messageError('注册资金(万元)必填!')
			}
			if (!this.MateFrom.cycle_km) {
				return messageError('开模周期必填!')
			}
			if (!this.MateFrom.cycle_dy) {
				return messageError('打样周期必填!')
			}
			if (!this.MateFrom.cycle_bj) {
				return messageError('产品报价回复周期必填!')
			}
			if (!this.MateFrom.cycle_dd) {
				return messageError('订单周期必填!')
			}
			if (!this.MateFrom.min_yn) {
				return messageError('是否有最小生产批量必填!')
			}
			if (this.MateFrom.min_yn === '是' && !this.MateFrom.min_prod) {
				return messageError('最小生产批量必填!')
			}
			if (!this.MateFrom.jh_address) {
				return messageError('交货地点必填!')
			}

      //人员信息
      if (!this.MateFrom.gys_yg) {
				return messageError('员工总人数必填!')
			}
			if (!this.MateFrom.yg_yf) {
				return messageError('研发人员必填!')
			}
			if (!this.MateFrom.yg_js) {
				return messageError('技术人员必填!')
			}
			if (!this.MateFrom.yg_sc) {
				return messageError('生产工人必填!')
			}

      //付款信息
      if (!this.MateFrom.pay_specs) {
				return messageError('账期规范必填!')
			}
			if (!this.MateFrom.pay_time) {
				return messageError('账期必填!')
			}
			if (!this.MateFrom.bank_name) {
				return messageError('开户行必填!')
			}
			if (!this.MateFrom.bank_num) {
				return messageError('账号必填!')
			}
			if (!this.MateFrom.cnaps_code) {
				return messageError('联行号必填!')
			}else if(this.MateFrom.cnaps_code){
				var regex = /^\d{12}$/; // 定义正则表达式，^开头$结尾\d为任意数字0-9，{12}限制长度为12位
                  if(!regex.test(this.MateFrom.cnaps_code)){
					return messageError('联行号不是有效的12位数字!');
				}
			}

     //营业执照（三证合一）
      if (this.fileList.xgzl_yyzz.length > 0 &&  this.MateFrom.yyzz_date == '') {
        return messageError('第1行有效日期必填!')
      }
      if (this.yyzz == 2 && this.fileList.xgzl_yyzz.length == 0){
          return messageError("[营业执照（三证合一）]必填!");
      }
      //产品检测报告
      if (this.fileList.xgzl_cpjc.length > 0 && this.MateFrom.cpjc_date == '') {
        return messageError('第2行有效日期必填!')
      }
      if (this.cpjc == 2 && this.fileList.xgzl_cpjc.length == 0){
          return messageError('[产品检测报告]必填!');
      }
      //生产许可证
      if (
        this.fileList.xgzl_scxk.length > 0 &&
        this.MateFrom.scxk_date == ''
      ) {
        return messageError('第3有效日期必填!')
      }
      if (this.scxk == 2 && this.fileList.xgzl_scxk.length == 0){
          return messageError('[生产许可证]必填!');
      }

      //安全生产许可证
      if (
        this.fileList.xgzl_aqxk.length > 0 &&
        this.MateFrom.aqxk_date == ''
      ) {
        return messageError('第4行有效日期必填!')
      }
      if (this.aqxk == 2 && this.fileList.xgzl_aqxk.length == 0){
          return messageError('[安全生产许可证]必填!');
      }

      //污染物排放许可证
      if (
        this.fileList.xgzl_wrw.length > 0 &&
        this.MateFrom.wrw_date == ''
      ) {
        return messageError('第5行有效日期必填!')
      }
      if (this.wrw == 2 && this.fileList.xgzl_wrw.length == 0){
          return messageError('[污染物排放许可证]必填!');
      }
      //印刷许可证
      if (
        this.fileList.xgzl_jyys.length > 0 &&
        this.MateFrom.jyys_date == ''
      ) {
        return messageError('第6行有效日期必填!')
      }
      if (this.jyys == 2 && this.fileList.xgzl_jyys.length == 0){
          return messageError('[印刷许可证]必填!');
      }
      //3C认证
      if (
        this.fileList.xgzl_ccc.length > 0 &&
        this.MateFrom.ccc_date == ''
      ) {
        return messageError('第7行有效日期必填!')
      }
      if (this.ccc == 2 && this.fileList.xgzl_ccc.length == 0){
          return messageError('[3C认证]必填!');
      }
      //危险化学品经营许可证
      if (
        this.fileList.xgzl_wxp.length > 0 &&
        this.MateFrom.wxp_date == ''
      ) {
        return messageError('第8行有效日期必填!')
      }
      if (this.wxp == 2 && this.fileList.xgzl_wxp.length == 0){
          return messageError('[危险化学品经营许可证]必填!');
      }
      //国际产品认证
      if (
        this.fileList.xgzl_gjcp.length > 0 &&
        this.MateFrom.gjcp_date == ''
      ) {
        return messageError('第9行有效日期必填!')
      }
      if (this.gjcp == 2 && this.fileList.xgzl_gjcp.length == 0){
          return messageError('[国际产品认证]必填!');
      }
      //质量管理体系
      if (this.fileList.xgzl_qms.length > 0 && this.MateFrom.qms_date == '') {
        return messageError('第10行有效日期必填!')
      }
      if (this.qms == 2 && this.fileList.xgzl_qms.length == 0){
          return messageError('[质量管理体系]必填!');
      }
      //环境管理体系
      if (this.fileList.xgzl_ems.length > 0 && this.MateFrom.ems_date == '') {
        return messageError('第11行有效日期必填!')
      }
      if (this.ems == 2 && this.fileList.xgzl_ems.length == 0){
          return messageError('[环境管理体系]必填!');
      }
      //职业健康安全管理体系
      if (this.fileList.xgzl_zyjk.length > 0 && this.MateFrom.zyjk_date == '') {
        return messageError('第12行有效日期必填!')
      }
      if (this.zyjk == 2 && this.fileList.xgzl_zyjk.length == 0){
          return messageError('[职业健康安全管理体系]必填!');
      }
      //高新技术企业认证
      if (this.fileList.xgzl_gxqy.length > 0 && this.MateFrom.gxqy_date == '') {
        return messageError('第13行有效日期必填!')
      }
      if (this.gxqy == 2 && this.fileList.xgzl_gxqy.length == 0){
          return messageError('[高新技术企业认证]必填!');
      }
      //商标注册证
      if (this.fileList.xgzl_xbzc.length > 0 && this.MateFrom.xbzc_date == '') {
        return messageError('第14行有效日期必填!')
      }
      if (this.xbzc == 2 && this.fileList.xgzl_xbzc.length == 0){
          return messageError('[商标注册证]必填!');
      }
      //其他文件
      if (this.otherfile == 2 && this.fileList.xgzl_other.length == 0){
          return messageError('[其他文件]必填!');
      }
       //半年流水额附件
      if (this.xgzl_bnlse == 2 && this.fileList.xgzl_bnlse.length == 0){
          return messageError('[半年流水额附件]必填!');
      }

      //人员管理文件
      if (this.personfile == 2 && this.fileList.person_file.length == 0){
          return messageError('[人员管理文件]必填!');
      }
      //质量管理文件
      if (this.qualityfile == 2 && this.fileList.quality_file.length == 0){
          return messageError('[质量管理文件]必填!');
      }
      //技术文件
      if (this.skillfile == 2 && this.fileList.skill_file.length == 0){
          return messageError('[技术文件]必填!');
      }
      //十环认证
      if (this.shrz == 2 && this.fileList.xgzl_ring.length == 0){
          return messageError('[十环认证]必填!');
      }
      //消防验收合格证
      if (this.xf == 2 && this.fileList.xgzl_xfys.length == 0){
          return messageError('[消防验收合格证]必填!');
      }
      //环境保护验收报告
      if (this.hjbh == 2 && this.fileList.xgzl_hjbh.length == 0){
          return messageError('[环境保护验收报告]必填!');
      }
      //一般纳税人证明
      if (this.nsrzm == 2 && this.fileList.xgzl_nxrzm.length == 0){
          return messageError('[一般纳税人证明]必填!');
      }
      //组织架构图
      if (this.zzjg == 2 && this.fileList.comp_zuzhi.length == 0){
          return messageError('[组织架构图]必填!');
      }
      //法人身份证
      if (this.sfz == 2 && this.fileList.person_id.length == 0){
          return messageError('[法人身份证]必填!');
      }
      //公司简介
      if (this.gsjj == 2 && this.fileList.comp_about.length == 0){
          return messageError('[公司简介]必填!');
      }
      //提交
      doSubmit(localStorage.getItem('userName')).then(res => {
        if (res.code === 200) {
          messageSuCcEss(res.msg);
        } else {
          messageError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
@import '../css/Main.css';
</style>



// WEBPACK FOOTER //
// src/components/GysMate.vue